import { Box, Text } from '@wix/design-system';
import type { FunctionComponent } from 'react';
import React, { useContext } from 'react';

import { RicosContext } from './../../ricos-context';
import { PoweredByGiphy } from './../icons';

import styles from './giphy-selector-scss';

export const GiphyErrorState: FunctionComponent<{}> = () => {
  const { t } = useContext(RicosContext);
  return (
    <>
      <div className={styles.giphySelectorErrorContainer}>
        <Box
          height="100%"
          alignContent="center"
          display="grid"
          textAlign="center"
          fontSize="14px"
          letterSpacing="1px"
          gap="12px"
        >
          <Text size="medium" weight="bold">
            {t('GiphyPlugin_ApiErrorMsg_Title')}
          </Text>
          <Text size="small" weight="thin">
            {t('GiphyPlugin_ApiErrorMsg_Subtitle')}
          </Text>
        </Box>
      </div>
      <Box display="block" width="100%" paddingTop="8px">
        <PoweredByGiphy className={styles.giphy_selector_powerdByGiphy} />
      </Box>
    </>
  );
};
